import React, { PureComponent } from 'react'
import { TableRow, TableCell, Button, MenuItem } from '@material-ui/core'
import { TableCellWithSwitch, TableCellWithTextField } from '../common/PureItems'
import { hasAccess } from '../../utils/api'
import moment from 'moment'
import EditActionComponent from '../common/EditActionComponent'
import { EditableSelect } from '../common/EditableComponents'
import { environmentOptions } from '../../utils/constants'

class LeaflyAccountItem extends PureComponent {
  onSave = () => {
    this.props.onSave(() => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  onChange =
    (key, isCheckBox = false) =>
    (event) => {
      this.props.onChange(key, isCheckBox ? event.target.checked : event.target.value)
    }

  onDelete = () => {
    const {
      data: { id },
      onDelete,
    } = this.props
    onDelete(id)
  }

  render() {
    const { shop = {}, data = {}, editMode = false } = this.props
    const { apiKey, lastSync, syncEnabled, environment } = data || {}

    return (
      <TableRow>
        <TableCell>{shop.name}</TableCell>
        <TableCellWithTextField
          valueToRender={apiKey || ''}
          value={apiKey || ''}
          editMode={editMode}
          onChange={this.onChange('apiKey')}
        />
        <TableCellWithTextField
          valueToRender={(lastSync && moment(lastSync).format('MM/DD/YYYY')) || ''}
          value={data.name}
          editMode={false}
          onChange={this.onChange('lastSync')}
        />
        <TableCell>
          <EditableSelect
            valueToRender={environment}
            editMode={editMode}
            value={environment}
            onChange={this.onChange('environment')}
          >
            {environmentOptions.map((env) => {
              return <MenuItem value={env.value}>{env.label}</MenuItem>
            })}
          </EditableSelect>
        </TableCell>
        <TableCellWithSwitch
          valueToRender={syncEnabled ? 'Enabled' : 'Disabled'}
          checked={syncEnabled}
          editMode={editMode}
          onChange={this.onChange('syncEnabled', true)}
        />
        {hasAccess() ? (
          <TableCell>
            <EditActionComponent
              onSave={this.onSave}
              onCancel={this.onCancel}
              onEdit={this.props.enableEdit}
              editMode={editMode}
            />
            {data.id && !editMode ? (
              <Button className="danger-button margin" onClick={this.onDelete}>
                Delete
              </Button>
            ) : null}
          </TableCell>
        ) : null}
      </TableRow>
    )
  }
}

export default LeaflyAccountItem



// WEBPACK FOOTER //
// ./src/components/Leafly/LeaflyAccountItem.js